import * as React from "react";
import { isNil } from "lodash";
import styled from "styled-components";

import { formatISODateTime } from "@/react/datetime";
import { EMPTY_ARRAY } from "@/react/empty";
import { CopyButton } from "@/react/components/CopyButton";

import { JobDetailsSection, SectionTitle, ScrollableContent } from "./styled";

const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
`;

const SummaryKey = styled.div`
  font-weight: bold;
`;

const SummaryValue = styled.div`
  display: flex;
`;

const NOT_APPLICABLE = "N/A";

const SummarySection = ({ job }) => {
  const summaryData = React.useMemo(() => {
    if (isNil(job)) {
      return EMPTY_ARRAY;
    }
    return [
      { key: "Job ID", value: job.jobId ?? NOT_APPLICABLE },
      { key: "Status", value: job.status ?? NOT_APPLICABLE },
      { key: "Action", value: job?.action ?? NOT_APPLICABLE },
      { key: "Customer ID", value: job?.customerId ?? NOT_APPLICABLE },
      {
        key: "Detail Attribute",
        value: job?.details ?? NOT_APPLICABLE,
      },
      { key: "Source", value: job?.source ?? NOT_APPLICABLE },
      { key: "Total No.", value: job?.stats?.totalJobs ?? NOT_APPLICABLE },
      {
        key: "No. Successful",
        value: job?.stats?.successes ?? NOT_APPLICABLE,
      },
      {
        key: "No. Failed",
        value: job?.stats?.failures ?? NOT_APPLICABLE,
      },
      {
        key: "Created At",
        value: job?.createdAt
          ? formatISODateTime(job.createdAt)
          : NOT_APPLICABLE,
      },
      {
        key: "Updated At",
        value: job?.updatedAt
          ? formatISODateTime(job.updatedAt)
          : NOT_APPLICABLE,
      },
    ];
  }, [job]);

  return (
    <JobDetailsSection>
      <SectionTitle>Summary</SectionTitle>
      <ScrollableContent>
        <SummaryGrid>
          {summaryData.map((item, index) => (
            <React.Fragment key={index}>
              <SummaryKey>{item.key}</SummaryKey>
              <SummaryValue>
                {item.value}
                <CopyButton value={item.value} />
              </SummaryValue>
            </React.Fragment>
          ))}
        </SummaryGrid>
      </ScrollableContent>
    </JobDetailsSection>
  );
};

export default SummarySection;
